import { useState } from "react";
import axios from "axios";
import { Loader2, X } from "lucide-react";
import { API, apiError } from "@/lib/api";

export const promoDiscount = (promo, subtotal) => {
  if (!promo) return 0;
  const raw = promo.type === "pourcentage" ? (subtotal * promo.value) / 100 : promo.value;
  return Math.round(Math.min(Math.max(raw, 0), subtotal) * 100) / 100;
};

export const PromoField = ({ quantity, promo, onChange }) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const apply = async () => {
    if (!code.trim()) return setError("Saisissez un code promo.");
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/promo/validate`, { code, quantity: Number(quantity) });
      onChange(data);
    } catch (e) {
      setError(apiError(e));
      onChange(null);
    } finally {
      setLoading(false);
    }
  };

  if (promo) {
    return (
      <div data-testid="promo-applied" className="flex items-center justify-between gap-3 rounded-xl bg-emerald-50 border border-emerald-200 px-4 py-3 text-sm text-emerald-800">
        <span>Code <strong>{promo.code}</strong> appliqué ({promo.type === "pourcentage" ? `−${promo.value} %` : `−${promo.value} €`} sur le produit)</span>
        <button type="button" onClick={() => { onChange(null); setCode(""); }} data-testid="promo-remove-button" aria-label="Retirer le code" className="p-1 rounded-full hover:bg-emerald-100">
          <X className="w-4 h-4" />
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1.5">
      <span className="text-sm font-semibold text-slate-800">Code promo <span className="font-normal text-slate-400">(facultatif)</span></span>
      <div className="flex gap-2">
        <input data-testid="promo-code-input" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); apply(); } }} className="field-input sm:max-w-[14rem] uppercase" />
        <button type="button" onClick={apply} disabled={loading} data-testid="promo-apply-button" className="btn-ghost-ice !py-2.5 !px-5">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Appliquer"}
        </button>
      </div>
      {error && <span data-testid="promo-error" className="text-xs font-medium text-orange-700">{error}</span>}
    </div>
  );
};
